<a
  class="clear-link"
  [routerLink]="
    slug() !== null
      ? ['/', language, 'eventnow', slug(), 'auction', auction().idAuction]
      : ['/', language, 'auction', auction().slug]
  "
  (click)="goToArticle()"
  aria-label="Go to auction details"
>
  <article
    #bidCard
    class="bid"
    [class.bidBox]="!isBranded()"
    [class.bidBoxBranded]="isBranded()"
    [class.disabled]="
      auction().buyItNow && auction().articleQty < 1 && idEvent !== -1
    "
    [class.dark]="dark()"
    [class.memorabid]="isMemorabid && !isPreEvent()"
    [class.marketplace]="!isMemorabid && !isPreEvent()"
    [class.pre-event]="isPreEvent()"
    (mouseenter)="onCardMouseEnter(bidCard)"
    (mouseleave)="onCardMouseLeave(bidCard)"
  >
    @if (isMemorabid && !isPreEvent()) {
      <header
        #bidHeader
        class="bidHeader bidHeaderGold text-uppercase"
        [class.bidPreEvent]="isPreEvent()"
      >
        {{ "IDS_SELLER_MEMORABID" | translate }}
      </header>
    } @else if (!isMemorabid && !isPreEvent()) {
      <header
        #bidHeader
        class="bidHeader bidHeaderMarketplace text-uppercase"
        [class.bidPreEvent]="isPreEvent()"
      >
        {{ "IDS_SELLER" | translate }} {{ auction().entityDescription }}
      </header>
    } @else {
      <header
        #bidHeader
        class="bidHeader bidPreEvent text-uppercase"
      >
        {{ "IDS_PRE_EVENT_NOW" | translate }}
      </header>
    }
    <div
      class="imageShowcase"
    >
      <div class="image-container">
        @let hasPhoto = auction().articlePhoto !== null && auction().articlePhoto.fullPath !== '';
        <img
          class="articleImage"
          [src]="hasPhoto ? auction().articlePhoto.fullPath + '?w=650' : '/assets/img/not-found.png'"
          [srcset]="hasPhoto ? getArticleImageSrcset(auction().articlePhoto.fullPath) : null"
          [attr.sizes]="hasPhoto ? articleImageSizes : null"
          [attr.loading]="articleImageLoadingMode()"
          decoding="async"
          alt="cover of the auction item"
        />
        @if (idEvent !== -1 && auction().buyItNow && auction().articleQty < 1) {
          <div class="overlay"></div>
          <img
            src="/assets/img/sold-out.png"
            alt="sold out"
            class="sold-out"
          />
        }
      </div>

      @if (isMemorabid) {
        <img
          class="bidImageTopLeft"
          src="/assets/img/memorabid-icon.svg"
          alt="Memorabid"
          loading="lazy"
        />
      }

      @if (authService.isAuthenticated()) {
        <button
          type="button"
          class="bidImageTopRight"
          [ngClass]="{
            bidImageTopRightMarketplace: !isMemorabid && !isPreEvent(),
            bidImageTopRightGold: isMemorabid && !isPreEvent(),
            bidImageTopRightPreEvent: isPreEvent(),
            bidImageTopRightStarred: isStarred()
          }"
          (click)="onToggleWishlist($event)"
          aria-label="Toggle wishlist"
        >
          <fa-icon
            [icon]="!isStarred() ? faHeartRegular : faHeart"
            size="lg"
          ></fa-icon>
        </button>
      }


      @if (showExpiringBadge()) {
        <div
          class="bidImageBottomLeft expired"
          [ngClass]="{ 'move-up': auction().hasUserBided && !auction().isFinished }"
        >
          <div class="bid-info-icon">
            <fa-icon [icon]="faFlag" size="sm"></fa-icon>
          </div>
          <span class="bidImageText text-uppercase">{{
            "IDS_EXPIRING" | translate
          }}</span>
        </div>
      }

      @if (auction().hasUserBided) {
        <div
          class="user-bid-label"
          [ngClass]="{
            outbid: !auction().isUserBestBider,
            reserveNotReached:
              auction().isUserBestBider && !auction().reservePriceReached
          }"
        >
          {{
            (auction().isUserBestBider
              ? auction().reservePriceReached
                ? "IDS_GRID_USER_BIDED"
                : "IDS_GRID_RESERVE_NOT_REACHED"
              : "IDS_GRID_USER_OUTBID"
            ) | translate
          }}
        </div>
      }
    </div>

    @if (minimal()) {
      <ng-container *ngTemplateOutlet="bidDetailsMinimal"></ng-container>
    } @else {
      <ng-container *ngTemplateOutlet="bidDetailsDefault"></ng-container>
    }
  </article>
</a>

<ng-template #bidDetailsDefault>
  <div class="d-flex flex-column justify-content-between h-100 mt-2">
    <ng-container *ngTemplateOutlet="title" />
    <div class="bid-details">
      @if (idEvent === -1) {
        <div class="bid-properties">
          {{ auction().articleProperties[1] }}
          @if (
            !!auction().articleProperties[1] && !!auction().articleProperties[0]
          ) {
            <span>|</span>
          }
          {{ auction().articleProperties[0] }}
        </div>
      }

      @if (idEvent === -1 && !auction().buyItNow) {
        @if (hasActiveCountdown()) {
          <div class="countdown-inline" [ngClass]="countdownValueClass()">
            <span class="countdown-inline-label text-uppercase">
              {{
                (timeDifferenceFromStart > 0
                  ? "IDS_EXPIRES_IN"
                  : "IDS_STARTING_IN"
                ) | translate
              }}
            </span>
            @if (countdownPrimaryPart(); as primaryPart) {
              <div class="countdown-inline-parts">
                <div class="countdown-inline-part">
                  <span class="countdown-inline-number">{{ primaryPart.value }}</span>
                  <span class="countdown-inline-unit text-uppercase">{{ primaryPart.labelKey | translate }}</span>
                </div>
                @if (countdownSecondaryPart(); as secondaryPart) {
                <div class="countdown-inline-divider"></div>
                <div class="countdown-inline-part">
                  <span class="countdown-inline-number">{{ secondaryPart.value }}</span>
                  <span class="countdown-inline-unit text-uppercase">{{ secondaryPart.labelKey | translate }}</span>
                </div>
                }
              </div>
              }
          </div>
        } @else if (
          hasExpiredCountdown() &&
          !showCoverReserveButton() &&
          !showProposal()
        ) {
          <div class="d-flex">
            <span class="time timeRed text-uppercase ps-0"
              ><b>{{ "IDS_EXPIRED" | translate }}</b></span
            >
          </div>
        }
      }
    </div>
  </div>
  <ng-container *ngTemplateOutlet="footer" />
</ng-template>

<ng-template #bidDetailsMinimal>
  <div class="d-flex flex-column justify-content-between h-100 mt-2">
    <ng-container *ngTemplateOutlet="title" />
  </div>

  <div class="my-2"></div>

  <ng-container *ngTemplateOutlet="footer" />
</ng-template>


<ng-template #title>
  <div
    class="bid-title-container"
  >
    <span
      class="bid-title"
      [ngClass]="[
        isPreEvent() ? 'pre-event' : isMemorabid ? 'memorabid' : 'marketplace'
      ]"
    >
      {{ auction().title }}
    </span>
  </div>
</ng-template>

<ng-template #footer>
  <footer
    class="bid-footer"
    [ngClass]="{
      'pre-event': isPreEvent(),

    }"
  >
    @if (showProposal()) {
      <div class="proposal-button-container">
        <button
          class="btn btn-primary proposal-button"
          [ngClass]="{
            'proposal-button-memorabid': isMemorabid,
            'proposal-button-marketplace': !isMemorabid,
          }"
          (click)="openProposalPopup($event)"
          type="button"
        >
          <span class="web">
            {{ "IDS_SEND_PROPOSAL_WEB" | translate }}
          </span>
          <span class="mobile">
            {{ "IDS_SEND_PROPOSAL_MOBILE" | translate }}
          </span>
        </button>
      </div>
    }

    @if (!showProposal() && showCoverReserveButton()) {
      <div class="proposal-button-container">
        <button
          class="btn btn-primary proposal-button reserve"
          (click)="openCoverReservePopup($event)"
          type="button"
        >
          {{ "IDS_COVER_RESERVE" | translate }}
        </button>
      </div>
    }

    @if (!showCoverReserveButton() && !showProposal()) {
      <div
        class="bid-footer-content"
        [class.justify-content-center]="!auction().buyItNow"
        [class.memorabid]="isMemorabid && !isPreEvent()"
        [class.marketplace]="!isMemorabid && !isPreEvent()"
        [class.pre-event]="isPreEvent()"
      >
        <div class="bid-text-content" [class.pre-event]="isPreEvent()">
          <span>
            {{
              auction().currentMaxOfferedPrice ?? auction().basePrice
                | number : "1.0-0" : "it"
            }}
            €
          </span>
        </div>
        @if (auction().buyItNow) {
          <div class="bid-text-label text-uppercase">
            {{
              auction().articleQty > 0
                ? (getCardActionLabel() | translate)
                : ((idEvent === -1 ? "IDS_SOLD_OUT" : "IDS_AWARDED_AUCTION_1")
                  | translate)
            }}
          </div>
        }
      </div>
    }
  </footer>
</ng-template>
